
export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    requestText() {
      return this.$t('product.form.button')
    },
    formAttrs() {
      return {
        subject: this.$t('product.form.subject'),
        meta: {
          productSku: this.product.sku,
          productName: this.product.name
        }
      }
    },
  }
}
